export default "__VITE_ASSET__DmLRG$w5__"